<template>
  <div id="app">
    <Login
      v-if='!loggedIn'
      @newRegister='registerTrigger'
      @login='loginTrigger'
    />
    <Home
      v-if='loggedIn && isMounted'
      :loggedIn='loggedIn'
      :newRegister='newRegister'
    />
  </div>
</template>

<script>
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import firebase from 'firebase'

export default {
  name: 'App',
  components: {
    Home,
    Login
  },
  data () {
    return {
      loggedIn: true,
      newRegister: false,
      isMounted: false
    }
  },
  methods: {
    loginTrigger() {
      this.newRegister = false
    },
    registerTrigger() {
      this.newRegister = true
    }
  },
  mounted () {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        this.loggedIn = false
        localStorage.clear()
      } else {
        this.loggedIn = true

        firebase.database().ref().child(user.uid).get().then((snapshot) => {
          if (snapshot.exists()) {
            localStorage.setItem('isTrainer', snapshot.val().isTrainer)
          }
        })

        localStorage.setItem('user', JSON.stringify(user))
        if (user.displayName == null) {
          localStorage.setItem('username', user.email.split('@')[0])
        } else {
          localStorage.setItem('username', user.displayName)
        }
        localStorage.setItem('photoURL', user.photoURL)

        this.$nextTick(() => {
          this.isMounted = true
        })          
      }
    })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: absolute;
  width: 100%;
}
</style>
